export const PUBLIC_ICON_URL = "https://design-system.arcade.dev/icons";
export const PUBLIC_VIDEO_URL = "https://design-system.arcade.dev/video";
